import React, { useEffect, useState, useMemo } from 'react';
import MUIDataTable from 'mui-datatables';
import axios from 'axios';
import config from '../config/config';
import {
  Menu,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  InputAdornment,
  Chip,
} from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const S = {
  white: '#ffffff',
  bg: '#f9fafb',
  border: '#e5e7eb',
  borderLight: '#f3f4f6',
  accent: '#111827',
  sub: '#6b7280',
  muted: '#9ca3af',
  green: '#059669',
  red: '#dc2626',
  font: "'Quicksand', 'Helvetica Neue', sans-serif",
  radius: '16px',
  radiusSm: '10px',
  shadow: '0 1px 3px rgba(0,0,0,0.05), 0 8px 24px rgba(0,0,0,0.06)',
};

const fieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: S.radiusSm,
    fontFamily: S.font,
    fontSize: '13.5px',
    fontWeight: 600,
    background: S.white,
    '& fieldset': { borderColor: S.border },
    '&:hover fieldset': { borderColor: '#9ca3af' },
    '&.Mui-focused fieldset': { borderColor: S.accent, borderWidth: '1.5px' },
  },
  '& .MuiInputLabel-root': { fontFamily: S.font, fontSize: '13px', fontWeight: 600 },
  '& .MuiInputLabel-root.Mui-focused': { color: S.accent },
};

const selectSx = {
  borderRadius: S.radiusSm,
  fontFamily: S.font,
  fontSize: '13.5px',
  fontWeight: 600,
  background: S.white,
  '& fieldset': { borderColor: S.border },
  '&:hover fieldset': { borderColor: '#9ca3af' },
  '&.Mui-focused fieldset': { borderColor: S.accent, borderWidth: '1.5px' },
};

const Students = () => {
  const [data, setData] = useState([]);
  const [termm, setTerm] = useState([]);
  const [selectedClass, setSelectedClass] = useState([]);
  const [selectedTerm, setSelectedTerm] = useState([]);
  const [total, setTotal] = useState(0);
  const [data2, setData2] = useState([]);
  const [total2, setTotal2] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [terms, setTerms] = useState([]);
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState('');

  const fetchTerms = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullterms`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setTerms(res.data.terms || res.data || []);
    } catch (err) {
      console.error('Error fetching terms:', err);
    }
  };

  const handleSearch = () => {
    setSearchText(inputValue);
    setPage(0);
  };

  const fetchStudents = async (page = 0, rowsPerPage = 10, searchText = '') => {
    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(config.API_URL + '/api/pullinvoices/' + termm, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page: page + 1, per_page: rowsPerPage, search: searchText },
      });
      setData(res.data.data);
      setTotal(res.data.total);
      fetchStudentsMain(termm);
    } catch (err) {
      console.error('Error fetching invoices:', err);
    } finally {
      setLoading(false);
    }
  };

  const setSearchTextTerm = (term) => {
    setTerm(term);
    fetchStudentsMain(term);
  };

  const formatCurrency = (amount, currency = 'USD') => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  const classGrades = [
    { value: 'PG', label: 'Playgroup (2-3 years)' },
    { value: 'PP1', label: 'Pre-primary 1 (4-5 years)' },
    { value: 'PP2', label: 'Pre-primary 2 (4-5 years)' },
    { value: 'G1', label: 'Grade 1 (6-8 years)' },
    { value: 'G2', label: 'Grade 2 (6-8 years)' },
    { value: 'G3', label: 'Grade 3 (6-8 years)' },
    { value: 'G4', label: 'Grade 4 (9 years)' },
    { value: 'G5', label: 'Grade 5 (9 years)' },
    { value: 'G6', label: 'Grade 6 (11 years)' },
  ];

  const fetchStudentsMain = async (term = null) => {
    setTerm(term);
    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(config.API_URL + '/api/pullinvoices/' + term, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page: page + 1, per_page: 1000, search: searchText },
      });
      const ress = await axios.get(config.API_URL + '/api/pullinvoices/' + term, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page: page + 1, per_page: rowsPerPage, search: searchText },
      });
      setData2(res.data.data);
      setTotal2(res.data.total);
      setData(ress.data.data);
      setTotal(ress.data.total);
    } catch (err) {
      console.error('Error fetching invoices:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents(page, rowsPerPage, searchText);
    fetchStudentsMain(termm);
    fetchTerms();
  }, [page, rowsPerPage, searchText]);

  const stats = useMemo(() => {
    const totalBalance = data2.reduce((sum, invoice) => sum + (Number(invoice.grand_total) || 0), 0);
    const moneyPaid = data2.reduce((sum, invoice) => sum + (Number(invoice.paid_amount) || 0), 0);
    const balance = data2.reduce((sum, invoice) => sum + (Number(invoice.balance) || 0), 0);
    return { totalBalance, moneyPaid, balance };
  }, [data2]);

  const MetricCard = ({ title, value, sub }) => (
    <Card
      elevation={0}
      sx={{
        background: S.white,
        borderRadius: S.radius,
        border: `1px solid ${S.border}`,
        height: '100%',
        transition: 'box-shadow 0.18s ease, transform 0.18s ease',
        '&:hover': {
          boxShadow: S.shadow,
          transform: 'translateY(-2px)',
        },
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Typography
          sx={{
            fontFamily: S.font,
            fontSize: '11px',
            fontWeight: 700,
            color: S.muted,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            mb: 1.5,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontFamily: S.font,
            fontSize: '26px',
            fontWeight: 700,
            color: S.accent,
            letterSpacing: '-0.03em',
            lineHeight: 1.1,
          }}
        >
          {value}
        </Typography>
        {sub && (
          <Typography sx={{ fontFamily: S.font, fontSize: '12px', color: S.muted, mt: 0.8 }}>
            {sub}
          </Typography>
        )}
      </CardContent>
    </Card>
  );

  const handleMenuClick = (event, student) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedStudent(student);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleView = () => {
    setOpenModal(true);
    handleMenuClose();
  };

  const DetailRow = ({ label, value, valueColor }) => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 1.5,
        borderBottom: `1px solid ${S.borderLight}`,
        '&:last-child': { borderBottom: 'none' },
      }}
    >
      <Typography sx={{ fontFamily: S.font, fontSize: '12.5px', fontWeight: 600, color: S.muted }}>
        {label}
      </Typography>
      <Typography
        sx={{
          fontFamily: S.font,
          fontSize: '13.5px',
          fontWeight: 700,
          color: valueColor || S.accent,
        }}
      >
        {value}
      </Typography>
    </Box>
  );

  const columns = useMemo(
    () => [
      {
        name: 'term',
        label: 'Term',
        options: {
          filter: true,
          customBodyRender: (value) => (
            <Chip
              label={value}
              size="small"
              sx={{
                fontFamily: S.font,
                fontWeight: 700,
                fontSize: '11.5px',
                bgcolor: S.borderLight,
                color: S.sub,
                borderRadius: '6px',
                height: 24,
              }}
            />
          ),
        },
      },
      {
        name: 'class_admitted_to',
        label: 'Class',
        options: {
          filter: true,
          filterOptions: classGrades.map((g) => g.value),
          customBodyRender: (value) => (
            <Typography sx={{ fontFamily: S.font, fontWeight: 700, fontSize: '13px', color: S.accent }}>
              {value}
            </Typography>
          ),
        },
      },
      {
        name: 'reference_no',
        label: 'Reference No',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontFamily: S.font, fontSize: '12.5px', color: S.muted, fontWeight: 600 }}>
              {value}
            </Typography>
          ),
        },
      },
      {
        name: 'admission_number',
        label: 'Admission No',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontFamily: S.font, fontSize: '13px', fontWeight: 600, color: S.sub }}>
              {value}
            </Typography>
          ),
        },
      },
      {
        name: 'name',
        label: 'Name',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontFamily: S.font, fontWeight: 700, fontSize: '13.5px', color: S.accent }}>
              {value}
            </Typography>
          ),
        },
      },
      {
        name: 'grand_total',
        label: 'Fee Amount',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontFamily: S.font, fontWeight: 700, fontSize: '13.5px', color: S.accent }}>
              {formatCurrency(value)}
            </Typography>
          ),
        },
      },
      {
        name: 'paid_amount',
        label: 'Fee Paid',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontFamily: S.font, fontWeight: 700, fontSize: '13.5px', color: S.green }}>
              {formatCurrency(value)}
            </Typography>
          ),
        },
      },
      {
        name: 'balance',
        label: 'Balance',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography
              sx={{
                fontFamily: S.font,
                fontWeight: 700,
                fontSize: '13.5px',
                color: value > 0 ? S.red : S.muted,
              }}
            >
              {formatCurrency(value)}
            </Typography>
          ),
        },
      },
      {
        name: 'created_at',
        label: 'Invoiced On',
        options: {
          filter: false,
          customBodyRender: (value) => (
            <Typography sx={{ fontFamily: S.font, fontSize: '12.5px', color: S.muted, fontWeight: 600 }}>
              {value}
            </Typography>
          ),
        },
      },
      {
        name: 'actions',
        label: 'Actions',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => (
            <IconButton
              onClick={(e) => handleMenuClick(e, data[tableMeta.rowIndex])}
              size="small"
              sx={{
                width: 32,
                height: 32,
                borderRadius: '8px',
                border: `1px solid ${S.border}`,
                color: S.sub,
                '&:hover': { background: S.bg, borderColor: '#9ca3af' },
              }}
            >
              <MoreVertIcon sx={{ fontSize: 16 }} />
            </IconButton>
          ),
        },
      },
    ],
    [data]
  );

  const options = useMemo(
    () => ({
      search: false,
      filter: true,
      download: true,
      print: true,
      pagination: true,
      serverSide: true,
      count: total,
      rowsPerPage,
      page,
      selectableRows: 'none',
      elevation: 0,
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
            setPage(tableState.page);
            break;
          case 'changeRowsPerPage':
            setRowsPerPage(tableState.rowsPerPage);
            setPage(0);
            break;
          default:
            break;
        }
      },
      onRowClick: (rowData, rowMeta) => {
        const student = data[rowMeta.dataIndex];
        navigate(`/students/${student.id}/viewinvoice`);
      },
      setTableProps: () => ({
        sx: {
          '& .MuiTableCell-head': {
            bgcolor: S.bg,
            color: S.muted,
            fontFamily: S.font,
            fontWeight: 700,
            fontSize: '11px',
            textTransform: 'uppercase',
            letterSpacing: '0.07em',
            borderBottom: `1px solid ${S.border}`,
            py: 1.8,
          },
          '& .MuiTableCell-body': {
            fontFamily: S.font,
            fontSize: '13px',
            color: S.sub,
            borderBottom: `1px solid ${S.borderLight}`,
            py: 1.6,
          },
          '& .MuiTableRow-root:hover': {
            bgcolor: S.bg,
            cursor: 'pointer',
          },
        },
      }),
    }),
    [total, page, rowsPerPage, data, navigate]
  );

  return (
    <Box sx={{ p: { xs: 3, md: 5 }, bgcolor: S.bg, minHeight: '100vh', fontFamily: S.font }}>
      <Box sx={{ mb: 5 }}>
        <Typography
          sx={{
            fontFamily: S.font,
            fontWeight: 700,
            fontSize: { xs: '22px', md: '26px' },
            color: S.accent,
            letterSpacing: '-0.03em',
            mb: 0.5,
          }}
        >
          Student Invoices
        </Typography>
        <Typography sx={{ fontFamily: S.font, fontSize: '13.5px', color: S.muted, fontWeight: 600 }}>
          Manage and track student fee invoices
        </Typography>
      </Box>

      <Grid container spacing={2.5} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4} >
          <MetricCard style={{background:'green'}}
            title="Total Fee Amount"
            value={formatCurrency(stats.totalBalance)}
            sub="Across all students"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MetricCard
            title="Total Paid"
            value={formatCurrency(stats.moneyPaid)}
            sub="Collected so far"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MetricCard
            title="Outstanding Balance"
            value={formatCurrency(stats.balance)}
            sub="Remaining to collect"
          />
        </Grid>
      </Grid>

      <Card
        elevation={0}
        sx={{ mb: 3, borderRadius: S.radius, border: `1px solid ${S.border}`, background: S.white }}
      >
        <CardContent sx={{ p: 2.5 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                placeholder="Search by name or admission number..."
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: S.muted, fontSize: 18 }} />
                    </InputAdornment>
                  ),
                }}
                sx={fieldSx}
              />
            </Grid>
            <Grid item xs={12} md={2.5}>
              <Select
                fullWidth
                value={selectedClass}
                onChange={(e) => { setSelectedClass(e.target.value); setPage(0); }}
                displayEmpty
                sx={selectSx}
              >
                <MenuItem value="" sx={{ fontFamily: S.font, fontSize: '13px', fontWeight: 600 }}>All Classes</MenuItem>
                {classGrades.map((grade) => (
                  <MenuItem key={grade.value} value={grade.value} sx={{ fontFamily: S.font, fontSize: '13px', fontWeight: 600 }}>
                    {grade.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} md={2.5}>
              <Select
                fullWidth
                value={selectedTerm}
                onChange={(e) => { setSelectedTerm(e.target.value); setPage(0); }}
                displayEmpty
                sx={selectSx}
              >
                <MenuItem value="" sx={{ fontFamily: S.font, fontSize: '13px', fontWeight: 600 }}>All Terms</MenuItem>
                {terms.map((term) => (
                  <MenuItem key={term.id} value={term.id} sx={{ fontFamily: S.font, fontSize: '13px', fontWeight: 600 }}>
                    {term.term}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} md={3}>
              <Button
                fullWidth
                onClick={handleSearch}
                variant="contained"
                sx={{
                  fontFamily: S.font,
                  fontWeight: 700,
                  fontSize: '13.5px',
                  color: S.white,
                  background: S.accent,
                  borderRadius: S.radiusSm,
                  height: '52px',
                  textTransform: 'none',
                  letterSpacing: '0',
                  boxShadow: 'none',
                  '&:hover': { background: '#1f2937', boxShadow: 'none' },
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '360px' }}>
          <CircularProgress size={32} sx={{ color: S.accent }} thickness={3} />
        </Box>
      ) : (
        <Card
          elevation={0}
          sx={{ borderRadius: S.radius, border: `1px solid ${S.border}`, overflow: 'hidden', background: S.white }}
        >
          <MUIDataTable
            title={
              <Typography
                sx={{ fontFamily: S.font, fontWeight: 700, fontSize: '15px', color: S.accent, py: 0.5 }}
              >
                All Invoices
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Card>
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          elevation: 0,
          sx: {
            borderRadius: '10px',
            border: `1px solid ${S.border}`,
            boxShadow: S.shadow,
            minWidth: 160,
            mt: 0.8,
          },
        }}
      >
        <MenuItem
          onClick={handleView}
          sx={{
            fontFamily: S.font,
            fontSize: '13px',
            fontWeight: 600,
            color: S.accent,
            px: 2,
            py: 1.3,
            '&:hover': { bgcolor: S.bg },
          }}
        >
          View Details
        </MenuItem>
      </Menu>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        PaperProps={{
          elevation: 0,
          sx: {
            borderRadius: S.radius,
            maxWidth: '560px',
            width: '100%',
            border: `1px solid ${S.border}`,
            boxShadow: S.shadow,
            fontFamily: S.font,
          },
        }}
      >
        <DialogTitle
          sx={{
            px: 3.5,
            pt: 3,
            pb: 2.5,
            borderBottom: `1px solid ${S.border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Typography sx={{ fontFamily: S.font, fontWeight: 700, fontSize: '16px', color: S.accent, letterSpacing: '-0.02em' }}>
              Invoice Details
            </Typography>
            {selectedStudent && (
              <Typography sx={{ fontFamily: S.font, fontSize: '12px', color: S.muted, mt: 0.3, fontWeight: 600 }}>
                {selectedStudent.name}
              </Typography>
            )}
          </Box>
          <IconButton
            size="small"
            onClick={() => setOpenModal(false)}
            sx={{
              width: 32,
              height: 32,
              borderRadius: '8px',
              border: `1px solid ${S.border}`,
              color: S.sub,
              '&:hover': { background: S.bg },
            }}
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ px: 3.5, py: 3 }}>
          {selectedStudent && (
            <>
              <Box
                sx={{
                  background: S.bg,
                  borderRadius: S.radiusSm,
                  border: `1px solid ${S.border}`,
                  px: 2.5,
                  py: 0.5,
                  mb: 2.5,
                }}
              >
                <DetailRow label="ID" value={selectedStudent.id} />
                <DetailRow
                  label="Class"
                  value={
                    <Chip
                      label={selectedStudent.class_admitted_to}
                      size="small"
                      sx={{ fontFamily: S.font, fontWeight: 700, fontSize: '11.5px', bgcolor: S.borderLight, color: S.sub, borderRadius: '6px', height: 22 }}
                    />
                  }
                />
                <DetailRow label="Reference No" value={selectedStudent.reference_no} />
                <DetailRow label="Admission No" value={selectedStudent.admission_number} />
                <DetailRow label="Name" value={selectedStudent.name} />
                <DetailRow label="Invoiced On" value={selectedStudent.created_at} />
              </Box>

              <Typography
                sx={{
                  fontFamily: S.font,
                  fontSize: '11px',
                  fontWeight: 700,
                  color: S.muted,
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  mb: 1.2,
                }}
              >
                Financial Summary
              </Typography>
              <Box
                sx={{
                  background: S.bg,
                  borderRadius: S.radiusSm,
                  border: `1px solid ${S.border}`,
                  px: 2.5,
                  py: 0.5,
                }}
              >
                <DetailRow label="Fee Amount" value={formatCurrency(selectedStudent.grand_total)} />
                <DetailRow label="Fee Paid" value={formatCurrency(selectedStudent.paid_amount)} valueColor={S.green} />
                <DetailRow
                  label="Balance"
                  value={formatCurrency(selectedStudent.balance)}
                  valueColor={selectedStudent.balance > 0 ? S.red : S.muted}
                />
              </Box>
            </>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3.5, pb: 3.5, pt: 2, borderTop: `1px solid ${S.border}` }}>
          <Button
            onClick={() => setOpenModal(false)}
            sx={{
              fontFamily: S.font,
              fontWeight: 700,
              fontSize: '13.5px',
              color: S.white,
              background: S.accent,
              borderRadius: '9px',
              textTransform: 'none',
              px: 3.5,
              py: 1.1,
              boxShadow: 'none',
              '&:hover': { background: '#1f2937', boxShadow: 'none' },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Students;